import React from 'react';
import { motion } from 'framer-motion';
const PAIN_POINTS = ['Tu bebé solo se duerme en tus brazos y se despierta exactamente cuando lo tocás la cuna.', 'Cada noche improvisás porque no sabés qué funciona y qué no.', 'Se despierta 3, 4 o 5 veces por noche y no entendés por qué.', 'Probaste de todo: el auto, el pecho, mecerlo, pasearlo, música, YouTube a las 2AM.', 'Estás tan agotada que durante el día no podés ser la madre o el padre que querés ser.', 'Sentís culpa si lo dejás llorar y sentís culpa si no lo dejás llorar.', 'Tu pareja y vos no están de acuerdo en cómo manejarlo y eso genera tensión.', 'Buscaste información pero hay tanta y tan contradictoria que terminás más confundida que antes.'];
export function PainSection() {
  return <section className="bg-soft-gray py-20 px-4" data-id="element-198">
      <div className="max-w-4xl mx-auto" data-id="element-199">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-200">
          ¿Te sentís identificada con alguna de estas situaciones?
        </motion.h2>

        <div className="space-y-4 mb-16" data-id="element-201">
          {PAIN_POINTS.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm" data-id="element-202">
              <span className="text-2xl flex-shrink-0" data-id="element-203">😩</span>
              <p className="text-lg text-navy/80 font-medium" data-id="element-204">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-white p-8 rounded-2xl shadow-soft border border-sky/20" data-id="element-205">
          <p className="text-xl text-navy mb-4 font-medium" data-id="element-206">
            Si dijiste sí a alguna de estas cosas, lo que te falta no es más
            esfuerzo ni más amor.
          </p>
          <p className="text-xl text-navy mb-4 font-medium" data-id="element-207">
            Lo que te falta es información clara sobre qué está pasando
            realmente en el sueño de tu bebé.
          </p>
          <p className="text-2xl text-navy font-bold text-sky" data-id="element-208">
            Y eso es exactamente lo que vas a encontrar acá.
          </p>
        </motion.div>

        <div className="mt-16 text-center" data-id="element-209">
          <a href="#compra" className="inline-block bg-gold hover:bg-gold-light text-navy text-lg font-bold py-4 px-8 rounded-full shadow-soft transition-all transform hover:scale-105" data-id="element-210">
            🔓 QUIERO DORMIR MEJOR ESTA NOCHE
          </a>
        </div>
      </div>
    </section>;
}